var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tcf align-stretch",class:{
      'tcf-mobile': _vm.isMobile
    },style:(_vm.layoutStyle)},[_c('div',{staticClass:"mobile-helper"},[_c('div',{staticClass:"tcf-left"},[_vm._t("left",null,{"isMobile":_vm.isMobile})],2),_c('div',{staticClass:"tcf-right",class:{ 'mt-4': _vm.isMobile }},[_vm._t("right",null,{"isMobile":_vm.isMobile,"on":_vm.$emit})],2),_vm._t("absolute")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }